import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterBranchPipe } from './filter-branch.pipe';
import { QuantityPerBranchPipe } from './quantity-per-branch.pipe';
import { CalcDiscountPerUserPipe } from './calc-discount-per-user.pipe';
import { CalcPendingToPayPipe } from './calc-pending-to-pay.pipe';

const declarations = [
  FilterBranchPipe,
  QuantityPerBranchPipe,
  CalcDiscountPerUserPipe,
  CalcPendingToPayPipe,
];

@NgModule({
  declarations,
  imports: [CommonModule],
  exports: declarations,
})
export class PipesCompraModule {}
